import { useContext } from 'react'
import OrderByTableContext from '../contexts/OrderByTableContext'

export default function useOrderByTable() {
    return useContext(OrderByTableContext)
}
